import React from 'react'

import TelephoneField from 'material-ui-phone-number'

const SimpleTelephoneField = ({ value, name, label, required, onChange, onBlur, classes }) =>
  <TelephoneField
    className={classes.Login__form_field}
    InputLabelProps={{
      classes: {
        root: classes.Login__form_field_label,
        focused: classes.Login__form_field_label_focused,
      },
    }}
    InputProps={{
      classes: {
        root: classes.Login__form_field_outlined_input,
        focused: classes.Login__form_field_focused,
        notchedOutline: classes.notchedOutline,
      }
    }}
    margin='normal'
    value={value}
    onChange={newValue => onChange({ target: { name, value: newValue } })}
    fullWidth
    defaultCountry='br'
    variant='outlined'
    label={label}
    name={name}
    onBlur={onBlur}
    required={required}
  />

export default SimpleTelephoneField
